import * as React from 'react';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as queryString from 'query-string';

import { AppState } from '../../../reducers';

import {
    setUserPhoneAction,
    setChannelUserIdAction,
    setChannelIdAction,
    setUserLangAction
} from '../../../actions/user';

import { SuccessView } from './SuccessView';
import i18next from 'i18next';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface SuccessContainerProps extends Props<SuccessContainer> {
    lang: string;
    userId: string;
    channelUserId: string;
    channelId: string;
}

interface SuccessContainerDispatch extends Props<SuccessContainer> {
    setLang: (lang: string) => any;
    setPhone: (phone: string) => any;
    setChannelUserId: (channelUserId: string) => any;
    setChannelId: (channelId: string) => any;
}

function mapProps(state: AppState, props: SuccessContainerProps): SuccessContainerProps {
    return {
        lang: state.userState.lang,
        userId: state.userState.userId,
        channelUserId: state.userState.channelUserId,
        channelId: state.userState.channelId,
    };
}

function mapDispatch(dispatch: Dispatch<any>): SuccessContainerDispatch {
    return {
        setLang: (lang: string) => dispatch(setUserLangAction(lang)),
        setPhone: (phone: string) => dispatch(setUserPhoneAction(phone)),
        setChannelUserId: (channelUserId: string) => dispatch(setChannelUserIdAction(channelUserId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
    };
}

class SuccessContainer extends React.Component<SuccessContainerProps & SuccessContainerDispatch & RouteProps> {
    async componentDidMount() {
        const { history, setPhone, setChannelUserId, setChannelId, setLang, lang } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const phone = params.phone;
            const channelUserId = params.user_id;
            const channelId = params.channel_id;
            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (channelId) {
                setChannelId(channelId);
            }
            if (phone) {
                setPhone(phone);
            }
            if (channelUserId) {
                setChannelUserId(channelUserId);
            }
        }
    }

    render() {
        document.title = i18next.t('successful_reg');
        const { history, userId, channelId, lang } = this.props;
        return (
            <SuccessView channelId={channelId} onOk={() => history.push(`/services?channel_id=${channelId}&user_id=${encodeURIComponent(userId)}&lang=${lang}`)} />
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(SuccessContainer));



// WEBPACK FOOTER //
// ./src/components/Registration/Success/SuccessContainer.tsx